import React from "react";
import { Lightbulb } from "lucide-react";

const SuggestedQuestions = ({ questions, onSelectQuestion }) => {
  if (!questions || questions.length === 0) {
    return null;
  }

  return (
    <div className="mb-6">
      <div className="flex items-center space-x-2 mb-4">
        <Lightbulb className="w-5 h-5 text-emerald-600" />
        <h3 className="text-sm font-semibold text-gray-700">Suggestions de questions</h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {questions.map((question, index) => (
          <button
            key={index}
            onClick={() => onSelectQuestion(question)}
            className="px-4 py-3 bg-white text-gray-700 rounded-xl text-sm hover:bg-emerald-50 hover:text-emerald-700 hover:border-emerald-300 transition-all border border-gray-200 shadow-sm hover:shadow-md text-left"
          >
            <span className="flex items-center space-x-2">
              <span className="w-6 h-6 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-xs font-bold">
                {index + 1}
              </span>
              <span className="truncate">{question}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuggestedQuestions;
